module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "portfolio"
  }, [_c('project-internal', {
    attrs: {
      "link": "zissel",
      "background": "#94825a",
      "tiles": "half"
    }
  }), _vm._v(" "), _c('project-internal', {
    attrs: {
      "link": "droplet",
      "background": "linear-gradient(45deg, #43b9c6, #7b99d6)",
      "tiles": "half"
    }
  }), _vm._v(" "), _c('project-internal', {
    attrs: {
      "link": "digital-data-collection",
      "logoSuffix": "svg",
      "background": "linear-gradient(45deg, #381b20, #ffbc97)",
      "tiles": "full"
    }
  }), _vm._v(" "), _c('project-internal', {
    attrs: {
      "link": "maria-jose-moreno",
      "background": "#b8b8b8",
      "tiles": "longer"
    }
  }), _vm._v(" "), _c('project-external', {
    attrs: {
      "title": "Dynamic Polyfill Module",
      "logoSuffix": "svg",
      "link": "https://www.npmjs.com/package/dynamic-polyfill",
      "background": "#CB3837",
      "tiles": "shorter"
    }
  }), _vm._v(" "), _c('project-internal', {
    attrs: {
      "link": "robots-and-ai",
      "background": "#f5f3f4",
      "tiles": "shorter"
    }
  }), _vm._v(" "), _c('project-internal', {
    attrs: {
      "link": "berlinfuchs",
      "background": "linear-gradient(45deg, #6bd8c6, #ff9a8c)",
      "tiles": "longer"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48e7b1c8"}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PortfolioWeb.vue
// module id = 67
// module chunks = 0